import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';
import { SUPPORTED_IMAGE_MIMETYPES } from '../utils/fileDropUtils';
import { CropConfig } from '../utils/imageCropUtils';
import { createGameImageCacheKey } from './useMediaPreFetcher';

export function useCroppedImage({
  fileId,
  cropConfig,
  fileMimetype,
  isDiscoverTemplate,
  isAuthenticated,
  isOwner,
}: {
  fileId?: string | null;
  cropConfig?: CropConfig | null;
  fileMimetype?: string | null;
  isDiscoverTemplate: boolean;
  isAuthenticated: boolean;
  isOwner: boolean;
}) {
  const { data, isFetching, error, isSuccess } = useQuery({
    queryKey: createGameImageCacheKey(fileId, cropConfig),
    queryFn: async () => {
      if (fileMimetype && SUPPORTED_IMAGE_MIMETYPES.includes(fileMimetype)) {
        if (fileId) {
          return backendService.instance.gameFiles.fetchCroppedImageV2({
            fileId,
            isFromDiscover: isDiscoverTemplate,
            isAuthenticated,
            cropConfig,
            isOwner,
          });
        }
      }
    },
    enabled:
      Boolean(fileId) &&
      !!fileMimetype &&
      !!SUPPORTED_IMAGE_MIMETYPES.includes(fileMimetype),
    staleTime: 1000 * 60 * 60,
  });

  return {
    imageUrl: data,
    error,
    isLoading: isFetching,
    isSuccess,
  };
}
